import * as React from "react";

function AssetConversationParticipantMuteOn(props) {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.53 4.652C1.565 5.967 1 7.55 1 9.25c0 2.252.996 4.29 2.598 5.78.182.17.29.412.247.657-.148.86-.552 1.75-1.224 2.65l-.049.067a.377.377 0 00.303.596c1.9 0 3.188-.711 4.067-1.604.188-.19.468-.245.727-.181A9.674 9.674 0 0010 17.5c1.576 0 3.06-.373 4.35-1.03L7.644 9.766a1 1 0 01-1.409-1.409L2.53 4.652zm14.255 10.012C18.165 13.214 19 11.32 19 9.25 19 4.701 14.963 1 10 1a9.507 9.507 0 00-5.296 1.583l5.426 5.425a1 1 0 01.862.862l5.793 5.794zM12 9a1 1 0 102 0 1 1 0 00-2 0zM.47.47a.75.75 0 011.06 0l18 18a.75.75 0 11-1.06 1.06l-18-18a.75.75 0 010-1.06z"
                fill="#fff"
            />
        </svg>
    );
}

function AssetConversationParticipantMuteOff(props) {
    return (
        <svg
            width={18}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 9a1 1 0 110-2 1 1 0 010 2zM9 9a1 1 0 110-2 1 1 0 010 2zM6 9a1 1 0 110-2 1 1 0 010 2zm3-9C4.037 0 0 3.701 0 8.25c0 2.252.996 4.29 2.598 5.78.182.17.29.412.247.657-.148.86-.552 1.75-1.224 2.65l-.049.067a.377.377 0 00.303.596c1.9 0 3.188-.711 4.067-1.604.188-.19.468-.245.727-.181A9.674 9.674 0 009 16.5c4.963 0 9-3.701 9-8.25C18 3.701 13.963 0 9 0z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetPersonnelRoleCallTaker(props) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11.091 8.473C9.85 7.23 9.383 7.298 7.766 8.155c-.983.52-1.35.286-2.78-1.143-1.429-1.43-1.663-1.795-1.142-2.779.858-1.617.925-2.081-.318-3.323C2.82.204 2.594 0 2.096 0 1.733 0 1.347.239.764.822c-.921.92-.994 1.711-.3 3.253.55 1.223 1.39 2.834 3.008 4.451 1.618 1.618 3.229 2.458 4.453 3.008 1.264.568 2.176.774 3.253-.3.585-.582.822-.969.822-1.332 0-.497-.203-.723-.909-1.429"
                fill="#8F8F94"
            />
        </svg>
    );
}

function AssetPersonnelRoleResponder(props) {
    return (
        <svg
            width={11}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11 2.5L9.5.5a3.47 3.47 0 01-1.63.38A3.38 3.38 0 015.5 0a3.38 3.38 0 01-2.37.88A3.47 3.47 0 011.5.5L0 2.5c.68 1.24 1.295 2.75.5 3.89a2.59 2.59 0 00.955 3.835L5.5 12l4.065-1.775A2.59 2.59 0 0010.5 6.39c-.795-1.14-.18-2.65.5-3.89zm-1.765.17v-.035.035z"
                fill="#8F8F94"
            />
        </svg>
    );
}

function AssetGeneralDisclosureIndicatorSmall(props) {
    return (
        <svg
            width={6}
            height={10}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1 1.5L4.5 5 1 8.5"
                stroke="#858594"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AssetGeneralDisclosureIndicatorMedium(props) {
    return (
        <svg
            width={6}
            height={10}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.707.293A1 1 0 10.293 1.707L1.707.293zM5 5l.707.707a1 1 0 000-1.414L5 5zM.293 8.293a1 1 0 101.414 1.414L.293 8.293zm0-6.586l4 4 1.414-1.414-4-4L.293 1.707zm4 2.586l-4 4 1.414 1.414 4-4-1.414-1.414z"
                fill="#4A77F3"
            />
        </svg>
    );
}

function AssetGeneralDisclosureIndicatorExtraLarge(props) {
    return (
        <svg
            width={10}
            height={16}
            className="icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M2 14l6-6-6-6"
                stroke="#858594"
                strokeWidth={2.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function AssetButtonSort(props) {
    return (
        <svg
            className="icon"
            width={14}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.65 10.5V3.052L1.601 4.101A.85.85 0 11.399 2.899l2.5-2.5a.847.847 0 011.207.004L6.6 2.9a.85.85 0 11-1.202 1.202L4.35 3.052V10.5a.85.85 0 01-1.7 0zm8.7-9a.85.85 0 00-1.7 0v7.448L8.601 7.899a.85.85 0 10-1.202 1.202l2.5 2.5a.847.847 0 001.207-.004L13.6 9.1a.85.85 0 10-1.202-1.202L11.35 8.948V1.5z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetButtonFilter(props) {
    return (
        <svg
            className="icon"
            width={14}
            height={10}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 2H1a1 1 0 010-2h12a1 1 0 110 2zM3 4h8a1 1 0 110 2H3a1 1 0 010-2zm6 4H5a1 1 0 100 2h4a1 1 0 100-2z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetButtonFilterClear(props) {
    return (
        <svg
            width={18}
            height={18}
            fill="none"
            className="filterButtonClear"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 18A9 9 0 109 0a9 9 0 000 18zM5.465 5.463a1 1 0 011.414 0L9 7.584l2.121-2.121a1 1 0 011.415 1.414l-2.122 2.121 2.122 2.122a1 1 0 11-1.414 1.414L9 10.413l-2.121 2.121a1 1 0 11-1.414-1.414l2.12-2.122-2.12-2.12a1 1 0 010-1.415z"
                fill="#000"
            />
        </svg>
    );
}

function AssetButtonFilterValueCellClear(props) {
    return (
        <svg
            width={8}
            height={8}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.707.293A1 1 0 10.293 1.707l2.121 2.121L.293 5.95a1 1 0 101.414 1.414l2.121-2.121L5.95 7.364A1 1 0 107.364 5.95L5.243 3.828l2.121-2.12A1 1 0 105.95.292L3.828 2.414 1.708.293z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetButtonFilterValueCellClearAll(props) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.707.293A1 1 0 10.293 1.707l2.121 2.121L.293 5.95a1 1 0 101.414 1.414l2.121-2.121L5.95 7.364A1 1 0 107.364 5.95L5.243 3.828l2.121-2.12A1 1 0 105.95.292L3.828 2.414 1.708.293z"
                fill="currentColor"
            />
        </svg>
    );
}

function AssetButtonSearch(props) {
    return (
        <svg
            className="icon"
            width={16}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.667 11.556a4.895 4.895 0 01-4.889-4.89 4.895 4.895 0 014.889-4.888 4.895 4.895 0 014.889 4.889 4.895 4.895 0 01-4.89 4.889zm8.875 2.1l-3.208-2.799a.445.445 0 01-.072-.581 6.634 6.634 0 00.944-4.924c-.51-2.624-2.627-4.738-5.254-5.23a6.68 6.68 0 00-7.83 7.83c.492 2.627 2.607 4.743 5.23 5.254a6.634 6.634 0 004.924-.944.446.446 0 01.581.072l2.8 3.208a1.336 1.336 0 101.886-1.885z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetButtonSettings(props) {
    return (
        <svg
            className="icon"
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.476 10.828l-1.496.427a.375.375 0 00-.263.29c-.066.33-.154.655-.263.974a.375.375 0 00.083.383l1.083 1.119a.376.376 0 01.055.448l-.467.809a.374.374 0 01-.416.176l-1.518-.38a.375.375 0 00-.373.119c-.22.251-.457.488-.707.71a.375.375 0 00-.12.372l.38 1.517a.375.375 0 01-.176.416l-.808.467a.375.375 0 01-.449-.055l-1.124-1.088a.375.375 0 00-.383-.084c-.317.109-.64.197-.968.264a.376.376 0 00-.29.263l-.428 1.5a.376.376 0 01-.361.272h-.934a.375.375 0 01-.36-.272l-.429-1.5a.376.376 0 00-.29-.263 7.777 7.777 0 01-.97-.261.375.375 0 00-.383.083L5.98 18.62a.374.374 0 01-.448.055l-.809-.467a.375.375 0 01-.176-.416l.38-1.52a.375.375 0 00-.119-.372 7.92 7.92 0 01-.71-.707.376.376 0 00-.372-.118l-1.517.38a.375.375 0 01-.416-.177l-.467-.809a.375.375 0 01.055-.448L2.465 12.9a.375.375 0 00.083-.384 7.785 7.785 0 01-.265-.972.375.375 0 00-.263-.289l-1.495-.427a.375.375 0 01-.272-.361v-.934a.375.375 0 01.272-.36l1.495-.428a.375.375 0 00.263-.29 7.79 7.79 0 01.263-.974.375.375 0 00-.083-.383L1.38 5.979a.375.375 0 01-.055-.449l.467-.808a.375.375 0 01.416-.176l1.519.38a.375.375 0 00.372-.12c.221-.25.457-.487.708-.708a.375.375 0 00.119-.373l-.38-1.517a.375.375 0 01.176-.416l.808-.467a.375.375 0 01.449.055l1.124 1.088a.375.375 0 00.384.084c.316-.109.64-.197.967-.264a.375.375 0 00.29-.263l.428-1.5a.375.375 0 01.361-.272h.934a.375.375 0 01.36.272l.43 1.5a.376.376 0 00.29.263c.328.066.652.153.97.261a.375.375 0 00.382-.083L14.02 1.38a.375.375 0 01.448-.055l.809.467a.375.375 0 01.176.416l-.38 1.52a.376.376 0 00.12.372c.25.22.488.457.71.707a.375.375 0 00.372.118l1.516-.38a.375.375 0 01.416.177l.467.808a.376.376 0 01-.056.449L17.535 7.1a.375.375 0 00-.083.384c.109.318.197.642.264.972a.376.376 0 00.264.289l1.495.427a.375.375 0 01.272.361v.934a.376.376 0 01-.271.36zM6.488 5.416a.19.19 0 00-.282-.054 5.98 5.98 0 000 9.275.19.19 0 00.282-.054l2.16-3.74a1.687 1.687 0 000-1.687l-2.16-3.74zM10 4.001c-.726 0-1.446.13-2.124.388a.188.188 0 00-.094.27l2.164 3.747a1.687 1.687 0 001.46.844h4.322a.19.19 0 00.188-.217A5.996 5.996 0 0010 4zm5.728 6.748h-4.32a1.687 1.687 0 00-1.462.844l-2.164 3.748a.189.189 0 00.094.27 5.998 5.998 0 008.04-4.644.19.19 0 00-.188-.217z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetsPositivityFeedbackPositive(props) {
    return (
        <svg
            width={29}
            height={32}
            className="icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#prefix__filter0_di)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 13.997h2.015a2 2 0 001.585-.78l3.985-5.18A2 2 0 0013 6.82v-3.82A.986.986 0 0114 2c1.283 0 3 1.5 3 4.499a13.366 13.366 0 01-.822 5.138.251.251 0 00.223.36h6.517a2.055 2.055 0 012.06 1.695 1.988 1.988 0 01-1.029 2.054 1.986 1.986 0 01-.285 3.627c.364.257.63.63.754 1.057.129.483.071.997-.16 1.44a1.8 1.8 0 01-1.552 1.094c.215.348.316.754.29 1.162a2.083 2.083 0 01-2.114 1.867h-7.46a8 8 0 01-4.438-1.343l-.48-.32a2 2 0 00-1.11-.336H5a.997.997 0 01-1-1v-7.998a1 1 0 011-1z"
                    fill="url(#prefix__paint0_linear)"
                />
            </g>
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={14.5}
                    y1={2}
                    x2={14.5}
                    y2={25.994}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={0.5} stopColor="#fff" stopOpacity={0.84} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0.63} />
                </linearGradient>
                <filter
                    id="prefix__filter0_di"
                    x={0}
                    y={0}
                    width={29}
                    height={31.994}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={2} />
                    <feGaussianBlur stdDeviation={2} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.159774 0" />
                    <feBlend
                        mode="overlay"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={1} />
                    <feGaussianBlur stdDeviation={0.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend in2="shape" result="effect2_innerShadow" />
                </filter>
            </defs>
        </svg>
    );
}

function AssetsPositivityFeedbackNeutral(props) {
    return (
        <svg
            width={32}
            height={32}
            className="icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#prefix__filter0_di)">
                <path
                    d="M24.47 5.5a12 12 0 10-16.94 17 12 12 0 0016.94-17zm-3.49 9.49h-10a1 1 0 010-2h10a1 1 0 110 2z"
                    fill="url(#prefix__paint0_linear)"
                />
            </g>
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={16}
                    y1={2}
                    x2={16}
                    y2={26}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={0.5} stopColor="#fff" stopOpacity={0.84} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0.63} />
                </linearGradient>
                <filter
                    id="prefix__filter0_di"
                    x={0}
                    y={0}
                    width={32}
                    height={32}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={2} />
                    <feGaussianBlur stdDeviation={2} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.159774 0" />
                    <feBlend
                        mode="overlay"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={1} />
                    <feGaussianBlur stdDeviation={0.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend in2="shape" result="effect2_innerShadow" />
                </filter>
            </defs>
        </svg>
    );
}

function AssetsPositivityFeedbackNegative(props) {
    return (
        <svg
            width={30}
            height={32}
            className="icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g filter="url(#prefix__filter0_di)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.995 4H8.39a2 2 0 001.11-.336l.48-.32A8.004 8.004 0 0114.42 2h7.46a2.083 2.083 0 012.115 1.868c.026.408-.075.815-.29 1.163a1.8 1.8 0 011.552 1.093c.232.443.29.958.16 1.441-.124.428-.39.8-.753 1.057a1.986 1.986 0 01.285 3.628 1.989 1.989 0 011.028 2.055A2.056 2.056 0 0123.918 16h-6.519a.251.251 0 00-.223.36c.608 1.643.887 3.39.822 5.14 0 3-1.718 4.5-3 4.5a.984.984 0 01-1.001-1v-3.82a2 2 0 00-.415-1.22l-3.986-5.18A2.001 2.001 0 008.011 14H5.995a1 1 0 01-1-1V5a1 1 0 011-1z"
                    fill="url(#prefix__paint0_linear)"
                />
            </g>
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={15.498}
                    y1={2}
                    x2={15.498}
                    y2={26}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" />
                    <stop offset={0.5} stopColor="#fff" stopOpacity={0.84} />
                    <stop offset={1} stopColor="#fff" stopOpacity={0.63} />
                </linearGradient>
                <filter
                    id="prefix__filter0_di"
                    x={0.995}
                    y={0}
                    width={29.005}
                    height={32}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy={2} />
                    <feGaussianBlur stdDeviation={2} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.159774 0" />
                    <feBlend
                        mode="overlay"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={1} />
                    <feGaussianBlur stdDeviation={0.5} />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                    <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend in2="shape" result="effect2_innerShadow" />
                </filter>
            </defs>
        </svg>
    );
}

function AssetButtonNavBack(props) {
    return (
        <svg
            width={7}
            height={12}
            className="icon"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.707 1.707A1 1 0 105.293.293l1.414 1.414zM1 6l-.707-.707a1 1 0 000 1.414L1 6zm4.293 5.707a1 1 0 101.414-1.414l-1.414 1.414zm0-11.414l-5 5 1.414 1.414 5-5L5.293.293zm-5 6.414l5 5 1.414-1.414-5-5L.293 6.707z"
                fill="currentColor"
            />
        </svg>
    );
}

function AssetPullDownMenuSortDesc(props) {
    return (
        <svg
            width={10}
            height={7}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.588 0a.588.588 0 00-.533.367.678.678 0 00.082.677L4.548 6.77A.571.571 0 005 7c.175 0 .34-.084.452-.229l4.412-5.727a.678.678 0 00.08-.677A.588.588 0 009.412 0H.588z"
                fill="#000"
            />
        </svg>
    );
}

function AssetPullDownMenuSortAsc(props) {
    return (
        <svg
            width={10}
            height={7}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.412 7a.588.588 0 00.533-.367.678.678 0 00-.082-.677L5.452.23A.571.571 0 005 0a.571.571 0 00-.452.229L.136 5.956a.678.678 0 00-.08.677A.588.588 0 00.587 7h8.824z"
                fill="#000"
            />
        </svg>
    );
}

function AssetTaskStatusInProgress(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M18 14a2.001 2.001 0 11.001-4.002A2.001 2.001 0 0118 14zm-6 0a2.001 2.001 0 11.001-4.002A2.001 2.001 0 0112 14zm-6 0a2.001 2.001 0 11.001-4.002A2.001 2.001 0 016 14zm6-14C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetTaskStatusClosed(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16.848 8.53l-5 8a1 1 0 01-1.555.177l-3-3a1 1 0 011.414-1.414l2.111 2.111 4.334-6.934a1 1 0 011.696 1.06zM12 0a12 12 0 100 24 12 12 0 000-24"
                fill="#4A77F3"
            />
        </svg>
    );
}

function AssetTaskStatusOverdue(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M12 19a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM10.944 5.447a1.505 1.505 0 012.112 0 1.46 1.46 0 01.413 1.069l-.21 6.757a.75.75 0 01-.75.727h-1.017a.749.749 0 01-.75-.724l-.211-6.761a1.461 1.461 0 01.413-1.068zM12 0a12 12 0 100 24 12 12 0 000-24"
                fill="#FF3B30"
            />
        </svg>
    );
}

function AssetTestRuleStatusFail(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16.707 15.293a1 1 0 11-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 01-1.414-1.414L10.586 12 7.293 8.707a1 1 0 011.414-1.414L12 10.586l3.293-3.293a1 1 0 011.414 1.414L13.414 12l3.293 3.293zM12 0a12 12 0 100 24 12 12 0 000-24z"
                fill="#E4593E"
            />
        </svg>
    );
}

function AssetTestRuleStatusSuccess(props) {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M16.848 8.53l-5 8a1 1 0 01-1.555.177l-3-3a1 1 0 011.414-1.414l2.111 2.111 4.334-6.934a1 1 0 011.696 1.06zM12 0a12 12 0 100 24 12 12 0 000-24z"
                fill="#50B133"
            />
        </svg>
    );
}

function AssetActivityIndicatorMedium(props) {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5 10a.833.833 0 00-.833-.833H.833a.833.833 0 100 1.666h3.334A.834.834 0 005 10zm.667 2.5a.834.834 0 00-1.134-.308l-2.866 1.666a.836.836 0 00.833 1.45l2.892-1.666a.833.833 0 00.275-1.142zm-4-6.358l2.891 1.666a.836.836 0 10.834-1.45L2.5 4.692a.836.836 0 10-.833 1.45zM7.5 14.333a.835.835 0 00-1.142.3L4.692 17.5a.836.836 0 101.45.833l1.666-2.891a.833.833 0 00-.308-1.109zm5-8.666a.833.833 0 001.142-.3l1.666-2.892a.836.836 0 00-1.45-.833l-1.666 2.891a.833.833 0 00.308 1.134zM14.333 7.5a.834.834 0 001.134.308l2.891-1.666a.836.836 0 10-.833-1.45l-2.892 1.666a.833.833 0 00-.3 1.142zm4 6.358l-2.891-1.666a.836.836 0 00-.834 1.45l2.892 1.666a.835.835 0 001.224-.943.836.836 0 00-.39-.507zM6.142 1.667a.836.836 0 10-1.45.833l1.666 2.892a.836.836 0 101.45-.834L6.142 1.667zm7.5 12.991a.836.836 0 00-1.45.834l1.666 2.891a.836.836 0 101.45-.833l-1.666-2.892zm5.525-5.491h-3.334a.833.833 0 000 1.666h3.334a.834.834 0 000-1.666zM10 0a.833.833 0 00-.833.833v3.334a.833.833 0 101.666 0V.833A.834.834 0 0010 0zm0 15a.833.833 0 00-.833.833v3.334a.833.833 0 001.666 0v-3.334A.834.834 0 0010 15z"
                fill="#000"
            />
        </svg>
    );
}

function AssetConversationParticipantPatient(props) {
    return (
        <svg
            width={36}
            height={36}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={36} height={36} rx={18} fill="#4ACEAA" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.313 12.75l.684-.913a.798.798 0 01.633-.3.75.75 0 01.6.352l1.21 1.937a.191.191 0 00.137.087.187.187 0 00.15-.054l.898-.89a.744.744 0 01.53-.219h2.658a.188.188 0 00.187-.188V9.75a.75.75 0 00-.75-.75H18a.75.75 0 00-.75.75v2.813a.187.187 0 00.188.187h1.875zm4.843.75L23.1 14.557a.751.751 0 01-1.166-.134l-1.192-1.904a.188.188 0 00-.309-.013l-.52.694a.758.758 0 01-.6.3H17.44a.187.187 0 00-.188.188V16.5a.75.75 0 00.75.75h8.25a.75.75 0 00.75-.75v-2.812a.187.187 0 00-.188-.188h-2.657zm-8.78 7.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm10.874-.375a.75.75 0 00-.75.75v2.438h-15v-4.313a.75.75 0 10-1.5 0v7.125a.75.75 0 001.5 0v-.563h15v.563a.75.75 0 001.5 0V21a.75.75 0 00-.75-.75zM24 22.5h-7.125a.375.375 0 01-.375-.375V20.25a.75.75 0 01.75-.75h5.25a1.875 1.875 0 011.875 1.875v.75A.375.375 0 0124 22.5z"
                fill="#fff"
            />
        </svg>
    );
}

function AssetConversationParticipantDoctor(props) {
    return (
        <svg
            width={36}
            height={36}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={36} height={36} rx={18} fill="#5279EB" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.23 19.453a3.11 3.11 0 01-2.113 2.943.388.388 0 00-.255.336 5.834 5.834 0 01-11.64-.557.575.575 0 00-.433-.553 4.73 4.73 0 01-3.197-2.89l-2.373-6.33a3.406 3.406 0 012.058-4.415.57.57 0 00.289-.242 1.56 1.56 0 11.183 1.872.198.198 0 00-.24-.032 1.838 1.838 0 00-.834 2.27l2.372 6.331a3.154 3.154 0 005.904 0l2.373-6.33a1.838 1.838 0 00-.834-2.27.198.198 0 00-.24.03 1.553 1.553 0 11.183-1.871.57.57 0 00.29.242 3.406 3.406 0 012.057 4.415l-2.373 6.33a4.727 4.727 0 01-3.197 2.89.576.576 0 00-.432.553 4.278 4.278 0 008.512.614.39.39 0 00-.251-.42 3.11 3.11 0 114.192-2.916zm-3.113-1.167a1.167 1.167 0 10.002 2.335 1.167 1.167 0 00-.002-2.335z"
                fill="#fff"
            />
        </svg>
    );
}

function AssetConversationParticipantMedic(props) {
    return (
        <svg
            width={36}
            height={36}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={36} height={36} rx={18} fill="#E05C54" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.364 26H10.636A1.636 1.636 0 019 24.364v-9.819a1.636 1.636 0 011.636-1.636h14.728A1.636 1.636 0 0127 14.545v9.819A1.636 1.636 0 0125.364 26zm-2.455-7.364a.41.41 0 00-.409-.409h-3.273v-3.273a.409.409 0 00-.409-.409h-1.636a.41.41 0 00-.41.41v3.272H13.5a.41.41 0 00-.41.41v1.636a.41.41 0 00.41.409h3.273v3.273a.41.41 0 00.409.409h1.636a.41.41 0 00.41-.41v-3.272H22.5a.41.41 0 00.41-.41v-1.636zm-.313-6.545h-.962a.512.512 0 01-.475-.322l-.802-2.004a.205.205 0 00-.19-.129h-4.334a.204.204 0 00-.19.129l-.802 2.005a.51.51 0 01-.474.32h-.964a.307.307 0 01-.284-.42l1.056-2.641A1.636 1.636 0 0115.695 8h4.61a1.636 1.636 0 011.52 1.029l1.056 2.641a.305.305 0 01-.14.385.307.307 0 01-.145.036z"
                fill="#fff"
            />
        </svg>
    );
}


function AssetConversationParticipantInterpreter(props) {
    return (
        <svg
            width={36}
            height={36}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={36} height={36} rx={18} fill="#6A46F0" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.606 15.143h-1.182a13.757 13.757 0 01-2.796 4.693 16.33 16.33 0 004.135 2.457.393.393 0 01.21.5l-.272.733a.377.377 0 01-.495.229 17.683 17.683 0 01-4.707-2.826 17.687 17.687 0 01-4.707 2.826.377.377 0 01-.495-.229l-.271-.733a.393.393 0 01.209-.5 16.33 16.33 0 004.135-2.457 13.756 13.756 0 01-2.796-4.693h-1.182a.393.393 0 01-.393-.393v-.786c0-.217.176-.393.393-.393h4.321v-1.178c0-.217.176-.393.393-.393h.786c.217 0 .393.176.393.393v1.178h4.321c.217 0 .393.176.393.393v.786a.393.393 0 01-.393.393zm-7.407 0a12.063 12.063 0 002.3 3.617 12.064 12.064 0 002.3-3.617h-4.6zm-4.682 8.643h-.906a.49.49 0 01-.461-.323l-.74-2.034H9.402l-.74 2.034a.49.49 0 01-.46.323h-.908a.295.295 0 01-.276-.396l3.715-10.216a.589.589 0 01.553-.388h1.24c.248 0 .469.155.553.388l3.715 10.216a.295.295 0 01-.277.396zm-4.611-9.244l-1.933 5.315h3.866l-1.933-5.315z"
                fill="#fff"
            />
        </svg>
    );
}

function AssetConversationParticipantOther(props) {
    return (
        <svg
            width={36}
            height={36}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={36} height={36} rx={18} fill="#858594" fillOpacity={0.14} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.187 27H9.815a.567.567 0 01-.562-.623C9.504 23.814 12.174 21 17.5 21s7.997 2.814 8.248 5.377a.567.567 0 01-.562.623zm-7.686-7.5c-2.4 0-4.497-2.083-4.497-5.438C13.004 11.175 14.819 9 17.5 9S22 11.175 22 14.063c0 3.354-2.097 5.437-4.498 5.437z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetConversationApplicant(props) {
    return (
        <svg
            width={37}
            height={37}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <circle cx="18.5" cy="18.5" r="18.5" fill="#8D248F" />
            <path d="M18.5 17C21.7812 17 24.5 14.3281 24.5 11C24.5 7.71875 21.7812 5 18.5 5C15.1719 5 12.5 7.71875 12.5 11C12.5 14.3281 15.1719 17 18.5 17ZM22.9531 18.5469L20 24L19.25 21.125L20.75 18.5H16.25L17.75 21.125L17 24L14 18.5469C10.625 18.6875 8 21.4531 8 24.8281V26.75C8 28.0156 8.98438 29 10.25 29H26.75C27.9688 29 29 28.0156 29 26.75V24.8281C29 21.4531 26.3281 18.6875 22.9531 18.5469Z" fill="white" />
        </svg>
    );
}

function AssetProviderRotationCellActivity(props) {
    return (
        <svg
            width={13}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 11.001a6.397 6.397 0 01-1.172-.124.644.644 0 00-.514.133 5.272 5.272 0 01-2.514.988.272.272 0 01-.254-.425c.351-.438.604-.947.74-1.491a.403.403 0 00-.151-.393A5.29 5.29 0 010 5.5C0 2.466 2.687 0 6 0c3.315 0 6.001 2.466 6.001 5.5 0 3.035-2.686 5.501-6 5.501z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetConversationListActionRotation(props) {
    return (
        <svg
            width={16}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5.842 12.714a3.019 3.019 0 00-1.641-1.786c.482-.365.8-.939.8-1.59 0-1.103-.898-2-2-2-1.103 0-2 .897-2 2 0 .65.316 1.223.798 1.59A3 3 0 000 13.67c0 .184.15.334.333.329h4.405a3.719 3.719 0 011.104-1.286zM10.158 12.714c.271-.8.873-1.448 1.641-1.786a1.99 1.99 0 01-.8-1.59c0-1.103.898-2 2-2 1.103 0 2 .897 2 2 0 .65-.316 1.223-.798 1.59A3 3 0 0116 13.67c0 .184-.15.334-.333.329h-4.405a3.71 3.71 0 00-1.104-1.286z"
                fill="#858594"
            />
            <path
                d="M10.667 16a.33.33 0 00.333-.329c0-1.226-.741-2.28-1.798-2.744.481-.366.798-.939.798-1.589 0-1.103-.897-2-2-2s-2 .897-2 2c0 .65.317 1.223.798 1.589A3.002 3.002 0 005 15.67c0 .185.15.329.333.329h5.334zM11.667 0H4.333c-.551 0-1 .444-1 .995v4.667c0 .551.449 1 1 1h.529l1.902 1.902a.334.334 0 00.57-.235V6.662h4.333c.551 0 1-.449 1-1V.995a.997.997 0 00-1-.995zm-1.354 4.667H5.667a.337.337 0 01-.334-.338c0-.184.15-.334.334-.334h4.646c.184 0 .333.15.333.334 0 .184-.15.338-.333.338zm0-1.334H5.667a.337.337 0 01-.334-.338c0-.184.15-.333.334-.333h4.646c.184 0 .333.15.333.333 0 .184-.15.338-.333.338zm0-1.333H5.667a.337.337 0 01-.334-.338c0-.184.15-.333.334-.333h4.646c.184 0 .333.149.333.333 0 .185-.15.338-.333.338z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetConversationListActionWorking(props) {
    return (
        <svg
            width={14}
            height={16}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.625 13.95v1.15c1.347 0 2.416-.49 3.233-1.15H6.625z"
                fill="#858594"
            />
            <path
                d="M.875 8.2v1.15c0 1.438 1.15 1.725 1.15 1.725s1.15 3.45 4.6 3.45"
                stroke="#858594"
                strokeWidth={1.15}
                strokeMiterlimit={10}
                strokeLinecap="round"
            />
            <path
                d="M12.95 8.775h-1.725C11.225 5.187 9.5 3.6 9.5 3.6 7.775 7.625 2.025 4.75 2.025 8.775H.3v-2.3C.3 2.45 3.75.15 6.625.15 8.925.15 9.5 1.3 9.5 1.3c2.3 0 3.45 2.875 3.45 5.175v2.3zM6.912 11.075h-.575a.863.863 0 000 1.725h.575a.863.863 0 000-1.725z"
                fill="#858594"
            />
            <path
                d="M7.2 12.225h2.875a2.3 2.3 0 002.3-2.3V8.2"
                stroke="#858594"
                strokeWidth={1.15}
                strokeMiterlimit={10}
                strokeLinecap="round"
            />
            <path
                d="M12.375 10.5h-1.15V7.625h1.15c.635 0 1.15.515 1.15 1.15v.575a1.15 1.15 0 01-1.15 1.15z"
                fill="#858594"
            />
        </svg>
    );
}

function AssetActivityConsortiumIndicator(props) {
    return (
        <svg
            width={10}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5 3c2.76 0 5-.67 5-1.5S7.76 0 5 0 0 .67 0 1.5 2.24 3 5 3zm0 7a13.886 13.886 0 01-3.825-.5A5.06 5.06 0 010 9v1.25C0 11.215 2.24 12 5 12s5-.785 5-1.75V9a5.06 5.06 0 01-1.175.5A13.886 13.886 0 015 10zm0-3a13.885 13.885 0 01-3.825-.5A5.06 5.06 0 010 6v1.5C0 8.33 2.24 9 5 9s5-.67 5-1.5V6a5.06 5.06 0 01-1.175.5A13.885 13.885 0 015 7zm0-3a13.885 13.885 0 01-3.825-.5A5.06 5.06 0 010 3v1.5C0 5.33 2.24 6 5 6s5-.67 5-1.5V3a5.06 5.06 0 01-1.175.5A13.885 13.885 0 015 4z"
                fill="#000"
            />
        </svg>
    );
}

export {
    AssetConversationParticipantMuteOn, AssetConversationParticipantMuteOff,
    AssetPersonnelRoleCallTaker, AssetPersonnelRoleResponder,
    AssetGeneralDisclosureIndicatorSmall, AssetGeneralDisclosureIndicatorMedium, AssetGeneralDisclosureIndicatorExtraLarge,
    AssetButtonSort, AssetButtonFilter, AssetButtonFilterClear, AssetButtonFilterValueCellClear, AssetButtonFilterValueCellClearAll,
    AssetButtonSearch, AssetButtonSettings, AssetButtonNavBack,
    AssetsPositivityFeedbackPositive, AssetsPositivityFeedbackNeutral, AssetsPositivityFeedbackNegative,
    AssetPullDownMenuSortDesc, AssetPullDownMenuSortAsc,
    AssetTaskStatusInProgress, AssetTaskStatusClosed, AssetTaskStatusOverdue,
    AssetTestRuleStatusFail, AssetTestRuleStatusSuccess, AssetActivityIndicatorMedium,
    AssetConversationParticipantPatient, AssetConversationParticipantDoctor, AssetConversationParticipantMedic,
    AssetConversationParticipantInterpreter, AssetConversationParticipantOther,
    AssetProviderRotationCellActivity,
    AssetConversationListActionRotation, AssetConversationListActionWorking,
    AssetActivityConsortiumIndicator,
    AssetConversationApplicant,
}